/* eslint-disable camelcase */
import messages from 'services/locales/en/messages';
import { ChannelResponse, ErrorResponse } from '../responses/responseTypes';

export const transformToError = (response: ErrorResponse) => {
  const { data } = response;

  if (!data) {
    return { message: messages.error.unknown };
  }

  return { message: response.data.error_description };
};
export const transformToChannel = ({
  created_at,
  ...data
}: ChannelResponse) => ({
  ...data,
  createdAt: created_at,
});

export const transformToChannels = (channels: ChannelResponse[]) =>
  channels.map(transformToChannel);
